/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Trial_EligibilityInputs */

const en_pricing_trial_eligibility = /** @type {(inputs: Pricing_Trial_EligibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free trial for new subscribers only.`)
};

const es_pricing_trial_eligibility = /** @type {(inputs: Pricing_Trial_EligibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prueba gratis solo para nuevos suscriptores.`)
};

/**
* | output |
* | --- |
* | "Free trial for new subscribers only." |
*
* @param {Pricing_Trial_EligibilityInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_trial_eligibility = /** @type {((inputs?: Pricing_Trial_EligibilityInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Trial_EligibilityInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pricing_trial_eligibility(inputs)
	return en_pricing_trial_eligibility(inputs)
});